export default __webpack_public_path__ + "static/media/elemento_2.d16d4c4d.svg";